var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearchFlow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H6.5C7.32843 0 8 0.671573 8 1.5V5.5C8 6.32843 7.32843 7 6.5 7H1.5C0.671573 7 0 6.32843 0 5.5V1.5ZM1.5 1.25C1.36193 1.25 1.25 1.36193 1.25 1.5V5.5C1.25 5.63807 1.36193 5.75 1.5 5.75H6.5C6.63807 5.75 6.75 5.63807 6.75 5.5V1.5C6.75 1.36193 6.63807 1.25 6.5 1.25H1.5Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.5C14 0.671573 14.6716 0 15.5 0H20.5C21.3284 0 22 0.671573 22 1.5V5.5C22 6.32843 21.3284 7 20.5 7H15.5C14.6716 7 14 6.32843 14 5.5V1.5ZM15.5 1.25C15.3619 1.25 15.25 1.36193 15.25 1.5V5.5C15.25 5.63807 15.3619 5.75 15.5 5.75H20.5C20.6381 5.75 20.75 5.63807 20.75 5.5V1.5C20.75 1.36193 20.6381 1.25 20.5 1.25H15.5Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14.5C14 13.6716 14.6716 13 15.5 13H20.5C21.3284 13 22 13.6716 22 14.5V18.5C22 19.3284 21.3284 20 20.5 20H15.5C14.6716 20 14 19.3284 14 18.5V14.5ZM15.5 14.25C15.3619 14.25 15.25 14.3619 15.25 14.5V18.5C15.25 18.6381 15.3619 18.75 15.5 18.75H20.5C20.6381 18.75 20.75 18.6381 20.75 18.5V14.5C20.75 14.3619 20.6381 14.25 20.5 14.25H15.5Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5C0 13.6716 0.671573 13 1.5 13H6.5C7.32843 13 8 13.6716 8 14.5V18.5C8 19.3284 7.32843 20 6.5 20H1.5C0.671573 20 0 19.3284 0 18.5V14.5ZM1.5 14.25C1.36193 14.25 1.25 14.3619 1.25 14.5V18.5C1.25 18.6381 1.36193 18.75 1.5 18.75H6.5C6.63807 18.75 6.75 18.6381 6.75 18.5V14.5C6.75 14.3619 6.63807 14.25 6.5 14.25H1.5Z",
    fill: "#3D3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.875H11.5V1.75L13.5 3.5L11.5 5.25V4.125H8.75V2.875Z",
    fill: "#3D3D3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 7.75V10.5H19.75L18 12.5L16.25 10.5H17.375V7.75H18.625Z",
    fill: "#3D3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17.125H10.5V18.25L8.5 16.5L10.5 14.75V15.875H13.25V17.125Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchFlow);
export default __webpack_public_path__ + "static/media/researchFlow.ca381aa872b40df38ddaaf091e149c19.svg";
export { ForwardRef as ReactComponent };